<!-- Content -->
<div class="header top">
  @if ((menuSharedFacade.currentSlideTitle$ | async); as title) {
    <h1 class="truncate"
      [innerHTML]="title | safeHtml">
    </h1>
  }
  @if ({images: (slideViewerFacade.currentSelectedSlideImages$ | async),
    themeColor: (slideViewerFacade.themeColor$ | async)}; as data) {
    <div class="button-group"
      >
      <!-- Virtual Pointer -->
      @if (data.images.length > 0 && data.images[0].fullSize !== null &&
        (isDeepzoom(page.mediaType) || isImage(page.mediaType))) {
        <div class="button icon-group"
          (click)="menuSharedFacade.requestToggleVirtualPointer()">
          @if ({themeClass: setThemeColor((menuSharedFacade.showVirtualPointer$ | async), data.themeColor)}; as virtualPointerData) {
            <i class="fa fa-arrow-pointer"
            [ngClass]="virtualPointerData.themeClass"></i>
            <label class="d-none d-md-inline-block"
              [ngClass]="virtualPointerData.themeClass">
              {{ 'virtual_pointer' | translate }}
            </label>
          }
        </div>
      }
      @if ({showFullscreen: (menuSharedFacade.showFullscreen$ | async),
        themeClass: setThemeColor((menuSharedFacade.showFullscreen$ | async), data.themeColor)}; as fullScreenData) {
        @if (data.images.length > 0 && data.images[0].fullSize !== null) {
          <div class="button icon-group"
            (click)="menuSharedFacade.requestToggleFullscreen()">
            @if (fullScreenData.showFullscreen === false) {
              <i class="fa fa-expand"
              [ngClass]="fullScreenData.themeClass"></i>
            }
            @if (fullScreenData.showFullscreen) {
              <i class="fa fa-compress"
              [ngClass]="fullScreenData.themeClass"></i>
            }
            @if (fullScreenData.showFullscreen === false) {
              <label class="d-none d-md-inline-block"
                [ngClass]="fullScreenData.themeClass">
                {{ 'fullscreen' | translate }}
              </label>
            }
            @if (fullScreenData.showFullscreen) {
              <label class="d-none d-md-inline-block"
                [ngClass]="fullScreenData.themeClass">
                {{ 'window' | translate }}
              </label>
            }
          </div>
        }
      }
      @if ((slideViewerFacade.currentSelectedSlideImageHasAnnotations$ | async)) {
        <!-- Marker -->
        @if ({themeClass: setThemeColor((menuSharedFacade.showMarkers$ | async), data.themeColor)}; as markerData) {
          <div class="button icon-group"
            (click)="menuSharedFacade.requestToggleMarker()">
            <i class="fa fa-location-dot"
            [ngClass]="markerData.themeClass"></i>
            <label class="d-none d-md-inline-block"
              [ngClass]="markerData.themeClass">
              {{ 'toggle_markers' | translate }}
            </label>
          </div>
        }
        <!-- Selftest -->
        @if ({themeClass: setThemeColor((menuSharedFacade.showSelftest$ | async), data.themeColor)}; as selftestData) {
          <div class="button icon-group"
            (click)="menuSharedFacade.requestToggleSelftest()">
            <i class="fa fa-check"
            [ngClass]="selftestData.themeClass"></i>
            <label class="d-none d-md-inline-block"
              [ngClass]="selftestData.themeClass">
              {{ 'selftest' | translate }}
            </label>
          </div>
        }
      }
    </div>
  }
</div>